import { useState } from 'react'
import { InputLabel } from '@mui/material'
import { Box } from '@mui/system'
import classNames from 'classnames'
import { useField } from 'formik'

import { InputField } from 'src/components/shared/ui/form/fields'
import { fieldsStyles } from 'src/components/shared/ui/form/fields/fieldsStyles'
import useNumberValidations from 'src/components/shared/ui/form/fields/hooks/useNumberValidations'
import { NumeroCompuestoFieldStyles as styles } from './NumeroCompuestoFieldStyles'

type Props = {
  ids: { number: string; year: string }
  label: string
  required?: boolean
  disabled?: boolean
}

function NumeroCompuestoField({
  label,
  ids,
  required = true,
  disabled = false
}: Props): JSX.Element {
  const { allowInteger } = useNumberValidations()
  const metaNumber = useField(ids.number)[1]
  const metaYear = useField(ids.year)[1]
  const [active, setActive] = useState(false)

  function isError() {
    return (
      (metaNumber?.error && metaNumber?.error !== '') || (metaYear?.error && metaYear?.error !== '')
    )
  }

  const inputClassNames = classNames({
    disabled,
    required,
    error: isError(),
    clearable: false
  })

  return (
    <Box
      sx={styles.wrapper}
      data-disabled={disabled}
      data-error={isError()}
      data-active={active}
      className="multiField"
    >
      <InputLabel sx={fieldsStyles.inputLabel} className={inputClassNames}>
        {label}
      </InputLabel>
      <Box display="flex" flexDirection="row" sx={styles.composeInput}>
        <InputField
          id={ids.number}
          maxLength={7}
          onChange={e => {
            allowInteger(e)
            const { value, maxLength } = e.target
            const formattedValue = value.replace(/[^0-9]/, '')

            if (formattedValue && formattedValue.length === maxLength) {
              document.getElementById(ids.year)?.focus()
            }
          }}
          required={required}
          clearable={false}
          disabled={disabled}
          spaceLabel={false}
          spaceError={false}
          sx={styles.input}
          onFocus={() => setActive(true)}
          onBlur={() => setActive(false)}
        />
        <Box component="span" sx={styles.separator} />
        <InputField
          id={ids.year}
          required={required}
          clearable={false}
          maxLength={4}
          onChange={allowInteger}
          disabled={disabled}
          spaceLabel={false}
          spaceError={false}
          sx={styles.input}
          onFocus={() => setActive(true)}
          onBlur={() => setActive(false)}
        />
      </Box>
      <Box component="span" sx={fieldsStyles.helpText}>
        {metaNumber?.error || metaYear?.error}
      </Box>
    </Box>
  )
}

export default NumeroCompuestoField
